import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { Contact } from 'app/models/dto/contact.model';

@Component({
  selector: 'app-business-personnel',
  templateUrl: './business-personnel.component.html',
  styleUrls: ['./business-personnel.component.scss']
})
export class BusinessPersonnelComponent implements OnInit, OnChanges {

  @Input() contact: Contact;
  contactElements: BusinessPersonnelContactElements[] = [];

  constructor() { }

  ngOnInit(): void {
    this.updateContactElements();
  }

  ngOnChanges(): void {
    this.updateContactElements();
  }

  updateContactElements(): void {
    if(!this.contact) {
      return;
    }
    this.contactElements = [];
    if (this.contact.title) {
      this.contactElements.push({label: 'Title', value: this.contact.title});
    }
    if (this.contact.mobilePhone) {
      this.contactElements.push({
        label: 'Mobile Phone',
        value: this.contact.mobilePhone,
        country: this.contact.mobile_phone_country_code.country.countryCode,
        phoneCountryCode: this.contact.mobile_phone_country_code.countryCode,
        pipe: 'phone'
      });
    }
    if (this.contact.workPhone) {
      this.contactElements.push({
        label: 'Work Phone',
        value: this.contact.workPhone,
        country: this.contact.work_phone_country_code.country.countryCode,
        phoneCountryCode: this.contact.work_phone_country_code.countryCode,
        pipe: 'phone'
      });
    }
    if (this.contact.email) {
      this.contactElements.push({label: 'Email', value: this.contact.email});
    }
    if (this.contact.percentOwnership !== undefined && this.contact.percentOwnership !== null && !isNaN(this.contact.percentOwnership)) {
      this.contactElements.push({label: 'Percent Ownership', value: this.contact.percentOwnership.toString() + '%'});
    }
    if (this.contact.ssnGuarded) {
      this.contactElements.push({label: 'SSN', value: this.contact.ssnGuarded.toString(), pipe: 'ssn'});
    }
    if (this.contact.birthDate) {
      this.contactElements.push({label: 'Date of Birth', value: this.contact.birthDate, pipe: 'date'});
    }
    if (this.contact.street) {
      let address: string = this.contact.street;
      if (this.contact.street2) {
        address += '\n' + this.contact.street2;
      }
      if (this.contact.street3) {
        address += '\n' + this.contact.street3;
      }
      let postalCode = '';
      if (this.contact.zipId) {
        postalCode = ' ' + this.contact.zipId;
        if (this.contact.zipExtra) {
          postalCode += '-' + this.contact.zipExtra;
        }
      }
      if (this.contact.city && this.contact.stateId) {
        address += '\n' + this.contact.city + ', ' + this.contact.stateId + postalCode;
      } else if (this.contact.city && !this.contact.stateId) {
        address += '\n' + this.contact.city + postalCode;
      } else if (this.contact.stateId && !this.contact.city) {
        address += '\n' + this.contact.stateId + postalCode;
      } else {
        address += '\n' + postalCode;
      }
      this.contactElements.push({label: 'Address', value: address, pipe: 'address'});
    }
  }
}

interface BusinessPersonnelContactElements {
  label: string;
  value: string;
  extraLabel?: string;
  country?: string;
  phoneCountryCode?: number;
  pipe?: string;
}

@Component({
  selector: 'app-business-personnel-basic',
  templateUrl: './business-personnel-basic.component.html',
  styleUrls: ['./business-personnel.component.scss']
})
export class BusinessPersonnelBasicComponent extends BusinessPersonnelComponent {

  /**
   * Array of contactElements to exclude from rendering - based on the contactElement.label
   */
  @Input() excludes: Array<string> = [];

  updateContactElements(): void {
    super.updateContactElements();
    this.contactElements = this.contactElements.filter( element => !this.excludes.includes(element.label) );
  }
}
